module.exports = __webpack_public_path__ + "img/info-7.5390d48a.svg";